

export default {
    getFilteredKabKot : (state) => (id) => state.kabupatenKotaList.filter(v => v.provinsi.id == id),
    getDetailKecamatan : (state) => (id) => state.kecamatanList.find(v => v.id == id),
    getDetailKabKot : (state) => (id) => state.kabupatenKotaList.find(v => v.id == id),
    getDetailProvinsi : (state) => (id) => state.provinsiList.find(v => v.id == id)
}
